import { createParser } from 'nuqs';

/**
 * Parses a value as a page number, returning the zero-based page index.
 * If the value is not a valid positive integer, `null` is returned.
 * The `serialize` function converts the zero-based page index back to a one-based page number string.
 */
export const parseAsPageNumber = createParser({
  parse(value) {
    const pageNumber = Number.parseFloat(value);
    if (isNaN(pageNumber)) {
      return null;
    }
    const isValid = Number.isInteger(pageNumber) && pageNumber > 0;
    if (!isValid) {
      return null;
    }
    return pageNumber - 1;
  },
  serialize(value) {
    if (value === null) {
      return '';
    }
    const isValid = Number.isInteger(value) && value >= 0;
    if (!isValid) {
      return '';
    }
    return (value + 1).toString();
  },
});
